import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useWhatsAppModal } from '@/contexts/WhatsAppModalContext';
import { cn } from '@/lib/utils';

interface WhatsAppButtonProps {
  text?: string;
  source: string;
  variant?: 'default' | 'whatsapp' | 'outline' | 'secondary' | 'ghost' | 'link' | 'destructive';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
  showIcon?: boolean;
  fullWidth?: boolean;
}

const WhatsAppButton: React.FC<WhatsAppButtonProps> = ({
  text = 'Falar com especialista',
  source,
  variant = 'default',
  size = 'lg',
  className,
  showIcon = true,
  fullWidth = false
}) => {
  const { openWhatsAppModal } = useWhatsAppModal();

  return (
    <Button
      variant={variant}
      size={size}
      onClick={() => openWhatsAppModal(source)}
      className={cn(fullWidth && 'w-full', className)}
    >
      {showIcon && <MessageCircle className="h-5 w-5 mr-2" />}
      {text}
    </Button>
  );
};

export default WhatsAppButton;
